import { useEffect, useRef } from 'react';

export const useComponentWillUnmount = (onUnmount = () => {}) => {
  const onUnmountRef = useRef(onUnmount);

  onUnmountRef.current = onUnmount;

  useEffect(() => () => onUnmountRef.current(), []);
};
